var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-switch" }, [
    _c(
      "div",
      {
        staticClass: "vuestic-switch-option true-option",
        class: { active: _vm.value },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.setValue(true)
          },
        },
      },
      [_vm._t("trueTitle")],
      2
    ),
    _c(
      "div",
      {
        staticClass: "vuestic-switch-option false-option",
        class: { active: !_vm.value },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.setValue(false)
          },
        },
      },
      [_vm._t("falseTitle")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }